<template>
  <div :class="$style.container">
    <ul :class="$style.behavior">
      <li v-if="abilityDetails.behavior !== undefined">ABILITY: {{ abilityDetails.behavior }}</li>
      <li v-if="abilityDetails.affects !== undefined">AFFECTS: {{ abilityDetails.affects }}</li>
      <li v-if="abilityDetails.damage_type !== 'None'">
        DAMAGE TYPE:
        <strong :class="$style[abilityDetails.damage_type.toLowerCase()]">{{
          abilityDetails.damage_type
        }}</strong>
      </li>
      <li v-if="abilityDetails.bkb_piercing !== undefined">
        PIERCES SPELL IMMUNITY:
        <template v-if="abilityDetails.bkb_piercing">
          <strong :class="$style.yes">Yes</strong>
        </template>
        <template v-else>No</template>
      </li>
      <li v-if="abilityDetails.dispellable !== undefined">
        DISPELLABLE:
        <template v-if="abilityDetails.dispellable === 'No'">
          <strong :class="$style.no">Cannot be dispelled</strong>
        </template>
        <template v-else-if="abilityDetails.dispellable === 'Strong'">
          <strong :class="$style.no">Strong Dispels Only</strong>
        </template>
        <template v-else>Yes</template>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ability-behavior',
  props: ['ability', 'abilityDetails'],
  computed: {
    cooldown() {
      if (this.abilityDetails.cooldown && this.ability.level >= 0) {
        return Array.isArray(this.abilityDetails.cooldown)
          ? this.abilityDetails.cooldown[this.ability.level - 1]
          : this.abilityDetails.cooldown
      }
      return null
    },
    manacost() {
      if (this.abilityDetails.mana_cost && this.ability.level >= 0) {
        return Array.isArray(this.abilityDetails.mana_cost)
          ? this.abilityDetails.mana_cost[this.ability.level - 1]
          : this.abilityDetails.mana_cost
      }
      return null
    }
  }
}
</script>

<style lang="scss" module>
.container {
  position: relative;
  color: var(--color_lightbluishgrey);
  font-size: 0.8rem;
  padding: 0 0.4rem 0.2rem 0.4rem;
  border-bottom: 0.1rem solid rgba(var(--color_white-rgb), 0.1);
}

.behavior {
  list-style: none;

  li {
    margin-bottom: 0.2rem;
  }

  .magical {
    color: var(--color_lightblue);
  }

  .physical {
    color: var(--color_lightred);
  }

  .pure {
    color: var(--color_yellow);
  }

  .yes {
    color: var(--color_green);
  }

  .no {
    color: var(--color_red);
  }
}
</style>
